export const NO_MANIFEST_ERROR = 'Could not load manifest';
export const NO_DATA_ERROR = 'Could not load data';
export const NO_PAGE_ERROR = 'Could not load page as it does not exist';
export const UNKNOWN_ERROR = 'Unknown error loading data';
